import React, { useRef, useState } from 'react';

import './index.css';
import FilterData from '../../../../components/FilterAnalyze/FilterData/FilterData';
import AttendanceTimeReportHuman from './Components/Reports/AttendanceTime/AttendanceTimeReportHuman';
import AttendanceTimeReportBot from './Components/Reports/AttendanceTime/AttendanceTimeReportBot';
import SessionAttendanceTime from './Components/Reports/AttendanceTime/SessionAttendanceTime';
import QueueTimeAttendanceTime from './Components/Reports/AttendanceTime/QueueTimeAttendanceTime';
import AttendanceTimeGraphic from './Components/Graphics/AttendanceTimeGraphic';

/**
 * Component for show the bot attendance time screen on reports
 *
 * @returns
 */
const TimeAttendance = ({ parentFilter, onClickFilter }) => {
  const [isCheck, setIscheck] = useState(false);
  const [refGraphic, setRefGraphic] = useState(useRef(null));

  const getChildRefGraphic = (ref) => {
    setRefGraphic(ref);
  };

  return (
    <div>
      <FilterData
        onClickFilter={onClickFilter}
        graphicReference={refGraphic}
        graphicName="time-attendance"
        showDownload
        showMoreFilters
      />
      <div className="container-check-human">
        <input
          id="check-human"
          type="checkbox"
          checked={isCheck}
          onChange={() => setIscheck(!isCheck)}
        />
        <label htmlFor="check-human">Considerar atendimento humano</label>
      </div>
      <div className="container-attendance-time">
        <AttendanceTimeReportBot componentData={{ parentFilter }} />
        <SessionAttendanceTime componentData={{ parentFilter }} />
      </div>

      <div className="container-attendance-time">
        {isCheck && (
          <>
            <AttendanceTimeReportHuman componentData={{ parentFilter }} />
            <QueueTimeAttendanceTime componentData={{ parentFilter }} />
          </>
        )}
      </div>

      <AttendanceTimeGraphic
        isCheck={isCheck}
        componentData={{ parentFilter }}
        getRefGraphic={getChildRefGraphic}
      />
    </div>
  );
};

export default TimeAttendance;
